import React, {useRef, useState} from 'react';
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';

import {
    FORM,
    info,
    infoMsg,
} from "../../../components/i18n/i18n";
import {
    ButtonCancel,
    ButtonSubmit,
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import {showToastCustom} from "../../../components/toast/customToast";
import * as Yup from "yup";
import { useForm} from "react-hook-form";
import TabOptionLangs from "./_langs";
import Switch from "react-bootstrap-switch";
import {TT_HISTORY} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import {setLoading, setViewMode} from "../../../redux/actions/generalActions/mainActions";
import {resetCombos, setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {save, update} from "../../../redux/actions/promo/tabOptionsActions";
import {connect} from "react-redux";

const TabOptionForm = (props) => {
    const { editMode, disableInputs, domainObject } = props.formProps;
    const translatableLangs = domainObject?.translatedLangs || []
    const [status, setStatus] = useState(editMode ? domainObject?.status : false);

    const [langs, setlangs] = useState(domainObject?.langs || []);

    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }


    const validationSchema = Yup.object().shape({
    });

    const {register, handleSubmit, reset} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            uid: domainObject?.uid,
            code: domainObject?.code,
            showOrder: domainObject?.showOrder,
        }
    });

    const onSubmit = (data, _) => {
        let dataRequest = {
            id: data.id,
            uid: data.uid,
            code: data.code,
            showOrder: data.showOrder,
            status: status,
            langs: langs,
        };
        if (!editMode) {
            //Save
            props.save(dataRequest)
        } else {
            //Update
            let id = domainObject.id;
            delete domainObject.id;
            if (JSON.stringify(domainObject) === JSON.stringify(dataRequest)) {
                return showToastCustom(info, infoMsg);
            }

            //dataRequest = {...dataRequest, id}

            props.update(id, dataRequest)

        }
        backToList()
    };

    const backToList = () => {
        reset()
        props.setItem(null)
        props.setForm(false, false, false)
        props.setViewMode('LIST')
    }

    const handleSwitchChange = () => {
        setStatus(!status);
    }


    return (<>
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label>ID</Label>
                                <Input type="id" name="id" id="id"
                                       disabled
                                       value={domainObject?.id || ''}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>Firebase ID</Label>
                                <Input type="id" name="uid" id="uid"
                                       disabled
                                       value={domainObject?.uid || ''}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="2">
                            <FormGroup>
                                <Label>Codigo</Label>
                                <Input type="text" name="code"
                                       placeholder="Codigo"
                                       innerRef={register}
                                       disabled={disableInputs}/>
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>Orden</Label>
                                <Input type="number" name="showOrder"
                                       placeholder="Orden"
                                       innerRef={register}
                                       disabled={disableInputs}/>
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>Activo</Label>
                                <br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        value={status}
                                        disabled={disableInputs}
                                        onChange={handleSwitchChange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <i className="fas fa-language mr-2"/>
                        Información internacional
                    </CardTitle>
                    <CardBody>
                        <TabOptionLangs
                            langs={langs}
                            setLangs={setlangs}
                            translatableLangs={translatableLangs}
                        />
                    </CardBody>
                    <CardBody className="border-top">
                        <div className="float-right">
                            <ButtonSubmit/>
                            <ButtonCancel onClick={backToList}/>
                        </div>
                    </CardBody>
                </Form>
            </CardBody>
        </Card>

        {
            showModal && <LogHistoryModal
                ref={ modalRef }
                item={ domainObject }
            />
        }
    </>)
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setViewMode,
    resetCombos,
    setItem,
    setForm,
    save,
    update,
    setLoading
})

export default connect(mapStateToProps, mapActionsToProps)(TabOptionForm)
